import {
  colorVariation,
  iconVariation,
  numberFormatToPtBr,
} from '@/utils';

export const formatNumberWithSuffixesCompact = (number, limit = 9999) => {
  const paramAsNumber = Number(number);

  const avoidRoundingIntegerNumber = (value) => {
    if (value <= limit) return value;

    const [first, second] = numberFormatToPtBr(value).split('.');

    const numbersJoined = `${first}${String(second).charAt(0)}`;
    const getSizeFromRemainingValue = String(value).substring(numbersJoined.length).length;

    const transformRemainingValueInZeros = Array.from({ length: getSizeFromRemainingValue }, () => '0');

    return Number([...numbersJoined, ...transformRemainingValueInZeros].join(''));
  };

  const numberWithoutRounding = avoidRoundingIntegerNumber(paramAsNumber);

  if (numberWithoutRounding <= limit) return numberFormatToPtBr(number);

  const numberFormatted = Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 1,

  }).format(numberWithoutRounding);

  return numberFormatted.includes('K') ? numberFormatted.toLowerCase() : numberFormatted;
};

const formattedLabel = (coordinate, exporting) => {
  const formattedPercent = coordinate.percent > 0 ? Math.round(coordinate.percent) : coordinate.percent;
  const formattedFansFinal = formatNumberWithSuffixesCompact(coordinate.y);
  const formattedVariation = numberFormatToPtBr(coordinate.period_variation);
  const variationColor = colorVariation(coordinate.period_variation);
  const variationIcon = iconVariation(coordinate.period_variation);

  const iconVariationDS = () => {
    return `
      <span class="label-item__ds-icon"
        style="background: ${variationColor}; 
        -webkit-mask-image: url(${variationIcon});
        mask-image: url(${variationIcon});"> 
      </span>
      <span class="label-item__variation-value" style="color: ${variationColor}">
        ${formattedVariation}%
      </span>
    `;
  };

  const iconVariationSVG = () => {
    if (coordinate.period_variation > 0) {
      return `
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15px" height="15px" viewBox="0 0 15 15" version="1.1">
            <path style=" stroke:none;fill-rule:nonzero;fill:rgb(9.411765%,74.901961%,16.078431%);fill-opacity:1;" d="M 8.125 12.5 L 6.875 12.5 L 6.875 5 L 3.4375 8.4375 L 2.550781 7.550781 L 7.5 2.601562 L 12.449219 7.550781 L 11.5625 8.4375 L 8.125 5 Z M 8.125 12.5 "/>
          </svg>
        </span>
        <span class="label-item__variation-value" style="color: ${variationColor}">
          ${formattedVariation}%
        </span>
      `;
    }

    return `
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15px" height="15px" viewBox="0 0 15 15" version="1.1">
          <path style=" stroke:none;fill-rule:nonzero;fill:rgb(49.411765%,49.803922%,50.980392%);fill-opacity:1;" d="M 2.5 6.875 L 2.5 8.125 L 10 8.125 L 6.5625 11.5625 L 7.449219 12.449219 L 12.398438 7.5 L 7.449219 2.550781 L 6.5625 3.4375 L 10 6.875 Z M 2.5 6.875 "/>
        </svg>
      </span>
      <span class="label-item__variation-value" style="color: ${variationColor}">
        ${formattedVariation}%
      </span>
    `;
  };

  return `
    <div class="label-item">
      <span class="label-item__name">${coordinate.name}</span>
      <span class="label-item__percent">${formattedPercent}%</span>
      <span class="label-item__fans">${formattedFansFinal}</span>
      <span class="label-item__variation">
        ${exporting ? iconVariationSVG() : iconVariationDS()}
      </span>
    </div>
  `;
};

export default formattedLabel;
